/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface TrackItTaskResultForEvaluationOption
 */
export interface TrackItTaskResultForEvaluationOption {
    /**
     * 
     * @type {string}
     * @memberof TrackItTaskResultForEvaluationOption
     */
    evaluationParameterId: string;
    /**
     * 
     * @type {number}
     * @memberof TrackItTaskResultForEvaluationOption
     */
    optionId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TrackItTaskResultForEvaluationOption
     */
    $type?: TrackItTaskResultForEvaluationOptionTypeEnum;
}


/**
 * @export
 */
export const TrackItTaskResultForEvaluationOptionTypeEnum = {
    PtwPtw100AppZeroApplicationSharedTrackItImportComponentDtoImportTrackItMeasurementDtoTrackItTaskResultForEvaluationOptionPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.TrackItImportComponent.Dto.ImportTrackItMeasurementDto+TrackItTaskResultForEvaluationOption, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type TrackItTaskResultForEvaluationOptionTypeEnum = typeof TrackItTaskResultForEvaluationOptionTypeEnum[keyof typeof TrackItTaskResultForEvaluationOptionTypeEnum];



/**
 * Check if a given object implements the TrackItTaskResultForEvaluationOption interface.
 */
export function instanceOfTrackItTaskResultForEvaluationOption(value?: unknown): value is TrackItTaskResultForEvaluationOption {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(TrackItTaskResultForEvaluationOptionTypeEnum)[0];
}

export function TrackItTaskResultForEvaluationOptionFromJSON(json: any): TrackItTaskResultForEvaluationOption {
    return TrackItTaskResultForEvaluationOptionFromJSONTyped(json, false);
}

export function TrackItTaskResultForEvaluationOptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrackItTaskResultForEvaluationOption {
    if (json == null) {
        return json;
    }
    return {
        
        'evaluationParameterId': json['evaluationParameterId'],
        'optionId': json['optionId'] == null ? undefined : json['optionId'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function TrackItTaskResultForEvaluationOptionToJSON(value?: TrackItTaskResultForEvaluationOption | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'evaluationParameterId': value['evaluationParameterId'],
        'optionId': value['optionId'],
        '$type': value['$type'],
    });
}

